import { Client } from '@/utils';
import { configFuntional as configFuntionalAPI } from '@/api';

const GET_FUNCRESOURCEBYFUNCID = 'configFuntional/GET_FUNCRESOURCEBYFUNCID';


export default {
    state:{
        resListByFuncId:[],
    },
    actions:{
        async [GET_FUNCRESOURCEBYFUNCID]({ commit }, { params = {}, frontCode = '', globalLoading = true } = {}) {
            commit(GET_FUNCRESOURCEBYFUNCID, await Client.get(configFuntionalAPI.getResourceListByFuncId, { params }, frontCode, globalLoading));
        },
    },
    mutations:{
        [GET_FUNCRESOURCEBYFUNCID](state,data) {
            state.resListByFuncId = data.resource;
        },
    }
}



// WEBPACK FOOTER //
// ./src/store/modules/configFuntional.js